/**
 * Зміни простого фільтра чипами (FLT-10): умова на чип у корені `and`. Розширений фільтр (корінь `or`
 * чи групи) чипами не змінюється — лише бічною панеллю (FLT-11). І що з цього — зміна подання:
 * дорівнює умові подання — чернетки немає (FLT-08). Модуль першого екрана, без UI.
 */
import type { FilterCondition, FilterNode } from '@clientline/contracts';
import { chipsOf } from './summary.ts';

/** Дерево з переліку умов кореня `and`: жодної — `null`, одна — сама умова. */
export function treeOf(conditions: readonly FilterCondition[]): FilterNode | null {
  if (conditions.length === 0) return null;
  if (conditions.length === 1) return conditions[0] as FilterCondition;
  return { and: conditions };
}

/** Умови простого фільтра; розширений — `null` (чипами не змінюється). */
export function simpleConditions(tree: FilterNode | null): FilterCondition[] | null {
  const chips = chipsOf(tree);
  if (chips.kind === 'none') return [];
  return chips.kind === 'simple' ? chips.conditions : null;
}

/** Замінити (`condition`) чи прибрати (`null`) умову `index` простого фільтра; `index` за межами — додати. */
export function withCondition(
  tree: FilterNode | null,
  index: number,
  condition: FilterCondition | null,
): FilterNode | null {
  const list = simpleConditions(tree);
  if (list === null) return tree;
  const next = [...list];
  if (index >= 0 && index < next.length) {
    if (condition) next[index] = condition;
    else next.splice(index, 1);
  } else if (condition) {
    next.push(condition);
  }
  return treeOf(next);
}

/**
 * Чернетка фільтра відносно умови подання: та сама умова — `undefined` (змін немає), без умови при
 * поданні без умови — теж `undefined`, інакше — нове дерево (`null` — людина прибрала умову подання).
 */
export function filterDraft(
  next: FilterNode | null,
  base: FilterNode | undefined,
): FilterNode | null | undefined {
  if (next === null) return base === undefined ? undefined : null;
  return base !== undefined && JSON.stringify(next) === JSON.stringify(base) ? undefined : next;
}
